/*
 * 系统配置级常量
 */
/* eslint-disable */
// 本地存储的前缀
export const STORAGE_PREFIX = 'lynj_storage_';
// base64加密前缀
export const BASE64_PREFIX = 'lynj_base64_';
// 接入服务器接口地址根目录
export const SERVER_BASE_URL = '/';

/*
 * 本项目后端响应编码常量
 */

// 登录失败
export const LOGIN_INCORRECT = 0;
// 响应成功
export const SUCCESS = 1200;
// 无权限
export const NO_PERMISSIONS = 1403;
// 未找到
export const NOT_FOUND = 1404;
// 业务错误
export const BUSINESS_ERROR = 1500;
// 参数错误
export const PARAMS_ERROR = 1600;
// 会话超时
export const OVERTIME = 1700;
// 于其他PC重复登录
export const DUPLICATE_LOGON = 1800;
// 系统错误
export const SYSTEM_ERROR = 2500;

/*
 * 业务级、初始化常量
 */

// 是
export const YES = 1;
// 否
export const NO = 2;
// 分页起始页码
export const PAGE_NUMBER = 1;
// 分页默认条数
export const PAGE_SIZE = 20;
// 角色类型
export const ROLE_TYPE = {
  管理员: 1,
  游客: 2
};
// 获取年数
export const YEAR_LIST = [
  new Date().getFullYear() + '年',
  new Date().getFullYear() - 1 + '年',
  new Date().getFullYear() - 2 + '年'
];
// 获取月份
export const MONTH_LIST = [{
    label: '1月',
    value: 1
  },
  {
    label: '2月',
    value: 2
  },
  {
    label: '3月',
    value: 3
  },
  {
    label: '4月',
    value: 4
  },
  {
    label: '5月',
    value: 5
  },
  {
    label: '6月',
    value: 6
  },
  {
    label: '7月',
    value: 7
  },
  {
    label: '8月',
    value: 8
  },
  {
    label: '9月',
    value: 9
  },
  {
    label: '10月',
    value: 10
  },
  {
    label: '11月',
    value: 11
  },
  {
    label: '12月',
    value: 12
  }
];



// WEBPACK FOOTER //
// ./src/config/const.js